import type { Meta } from "@/types/Meta";
import type { PredictionMarket } from "@/types/PredictionMarket";
import romanApi from "@roman/shared/lib/net/romanApi";
import useSWR, { type SWRConfiguration } from "swr";

export interface GetPublicPredictionMarketsResponse {
  predictionMarkets: PredictionMarket[];
  meta: Meta;
}

interface UseGetPublicPredictionMarketsProps {
  swrOptions?: SWRConfiguration;
  fetcher?: (url: string) => Promise<GetPublicPredictionMarketsResponse>;
}

export const getPublicPredictionMarketsFetcher = (url: string) => {
  return romanApi.get<GetPublicPredictionMarketsResponse>(url);
};

export const useGetPublicPredictionMarkets = ({ swrOptions, fetcher }: UseGetPublicPredictionMarketsProps) => {
  const entriesFetcher = fetcher || getPublicPredictionMarketsFetcher;

  const swrQuery = useSWR("/prediction-market/?status=Open", entriesFetcher, swrOptions);

  return {
    ...swrQuery,
    predictionMarkets: swrQuery.data?.predictionMarkets ?? [],
  };
};
